export default function Head() {
  return (
    <>
      <title>Portfolio | Amna Faiz - 2D Animator & Motion Designer</title>
            
      {/* Viewport & Charset */}
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      <meta charSet="UTF-8" />
      

      <meta
        name='description'
        content="Explore Amna Faiz's portfolio as a 2D animator and motion designer from Islamabad, Pakistan. Specializing in Adobe Creative Suite, Blender, and Maya for e-learning animations, digital media, and broadcast content."
      />
      <meta
        property='og:description'
        content="Amna Faiz | 2D Animator | Motion Designer | 3+ months of experience creating visually compelling animations for e-learning platforms, digital media, and broadcast using Adobe After Effects, Photoshop, Blender, and more."
      />
      <meta name='keywords' content="Amna Faiz, 2D animator, motion designer, Adobe After Effects, Adobe Photoshop, Blender, Maya, e-learning animation, digital media, Islamabad, Pakistan, animation portfolio, motion graphics, video editing, Khudi App" />
      
      <meta property='og:site_name' content="Amna Faiz's Portfolio" />
      <meta property='og:title' content='Portfolio | Amna Faiz - 2D Animator' />
      <meta property='og:url' content='https://theamnafaiz.fluxpert.com/' />
      <meta property="og:type" content="website" />
      
      <meta property='og:image' content='https://firebasestorage.googleapis.com/v0/b/studeoz-e762b.appspot.com/o/portfolio%2Fpersonal_pic%2Famna%2Fcropped-amna_faiz_profile.jpeg?alt=media&token=e35c1b82-bde0-4963-9a32-cb506118bb96' />
      
      <link rel='canonical' href='https://theamnafaiz.fluxpert.com/' />

      <meta name='author' content='Amna Faiz' />
      <meta name='language' content='English' />

      <meta name='application-name' content='Portfolio | Amna Faiz - 2D Animator' />
      <meta name='apple-mobile-web-app-title' content='Portfolio | Amna Faiz - 2D Animator' />
      
      <link rel='icon' href='/favicon.ico' />
      <meta property="og:title" content="Portfolio | Amna Faiz - 2D Animator" />

      {/* Structured Data (Schema.org) */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "Amna Faiz",
            "jobTitle": "2D Animator & Motion Designer",
            "url": "https://theamnafaiz.fluxpert.com/",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Islamabad",
              "addressCountry": "Pakistan"
            },
            "sameAs": [
              "https://www.linkedin.com/in/theamnafaiz",
              "mailto:amnafaiz999@gmail.com"
            ],
            "description": "A 2D animator with 3+ months of experience creating visually compelling animations and motion graphics for e-learning platforms, digital media, and broadcast using Adobe Creative Suite, Blender, and Maya."
          }
        `}
      </script>
    </>
  );
}
